import * as React from 'react';
import Typography from '@mui/material/Typography';
import classes from '../components/storeSelectComponent.module.css'
import { GiShop } from 'react-icons/gi';
import { loadStoreSettings } from '../services/productServices';
import { checkRegisterStatus } from '../services/storeServices';
import { useNavigate } from 'react-router-dom';
import OpenRegisterForm from './openRegisterFormComponent';
import { useState } from 'react';
import { Grid } from '@mui/material';
import { BsShop } from "react-icons/bs";
import shopIcon from "../assets/images/store.png"
import CloseRegisterForm from './closeRegisterForm';
import { getExpectedCash } from '../services/storeServices';
import LoaderDialogue from './loaderDialogueComponent';

export default function StoreItem(props) {

    const [openRegister, setOpenRegister] = useState(false)
    const [openCloseRegisterForm,setOpenCloseRegisterForm] = useState(false)
    const [openLoaderDialogue, setOpenLoaderDialogue] = useState(false)
    const [loaderDialogueText, setLoaderDialogueText]=useState("")
    const [expectedCash, setExpectedCash] = useState({
        cashsales:0,
        openingCash:0,
        totalSales:0
      })
    const navigate = useNavigate()
    const getStoreSettings = () => {
        loadStoreSettings(props.storeData.id).then(
            response => {
                
            }
        )
    }

    const storeID = localStorage.getItem("userStoreID")
    const registerID = localStorage.getItem("registerID")

     const handleCloseCloseRegisterForm = () => {
    setOpenCloseRegisterForm(false)
  }

    const fetchExpectedCash = async (storeid,registerid) => {
      
        setOpenLoaderDialogue(true)
        setLoaderDialogueText("The current register needs to be closed. Please wait while POS loads your transactional data...")
       await  getExpectedCash({storeID:storeid,registerID:registerid}).then(
          
          response=> {
            setExpectedCash(
              {
                cashsales:response.data.cash_sales,
                openingCash:response.data.opening_cash,
                totalSales:response.data.total_sales
              }
            )
              
            setOpenLoaderDialogue(false)
            setOpenCloseRegisterForm(true)
          }
        ).catch(
          error=> {
            setOpenLoaderDialogue(false)
            if (error.response.status === 401) {
              // setOpenLoaderDialogue(false)
              // setOpenAlert(true)
              // setAlertMessage('Your token has expired')
              Cookies.remove('loggedState')
              Cookies.remove('bearer')
              navigate('/ ')
              localStorage.clear()
          }
          else{
            
              setOpenLoaderDialogue(false)
              setOpenAlert(true)
              setAlertMessage('POS encountered an error. Please try again')
              
          }
          }
        )
      }

    const checkTheRegisterStatus = async () => {
        const userID = localStorage.getItem('userID')
        localStorage.setItem('userStoreID', props.storeData.id)
        await checkRegisterStatus(props.storeData.id, userID).then(
            response => {
              
                if (response.data.status === "success") {
                    localStorage.setItem('registerID', response.data.id)
                    localStorage.setItem('storeName', props.storeData.name)
                    navigate('/pos')
                }
                else if(response.data.status === "fail"){
                    props.openRegisterForm()
                }else if(response.data.status === "close_register"){
                  const registerid = response.data.id
                  localStorage.setItem('registerID', registerid)
                    // props.openRegisterForm()
                    
                    fetchExpectedCash(props.storeData.id,response.data.id)
                }
            }
        )

        .catch(error =>{
            alert("Error Opening Register, please try again")
        })
    }

    
    
    return (

        <Grid item xs={12} sm={6} md={4} lg={3}  onClick={checkTheRegisterStatus} sx={{ display: 'flex', justifyContent: "center", alignItems: 'center', maxWidth: '300px', minWidth: '300px', marginTop: 5, marginLeft: 5 }} className={classes.storeCard}>
            <div>
                <div className={classes.iconContainer}>
                    <div className={classes.iconContainerDiv}>
                        
                        <img src={shopIcon} alt="" className={classes.storeicon}/>
                    </div>
                    <Typography sx={{ padding: 3, color:'#a93c40' }}><p>{props.storeData.name}</p></Typography>
                </div>
                
            </div>
            <LoaderDialogue open={openLoaderDialogue} message={loaderDialogueText} />
            <CloseRegisterForm open ={openCloseRegisterForm} close={handleCloseCloseRegisterForm} cashExpected={expectedCash}/>
        </Grid>





    );
}